module.exports = __webpack_public_path__ + "img/line.7fb81b4f.svg";